"use client";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./page.scss";
import StatsWithLottie from "@/elements/StatsWithLottie";
const SectionStats = ({
  logos,
  size_in_billion,
  avg_salary_in_inr,
  jobs_in_market_2024,
  id,
  isSubIndustry
}: {
  logos: any;
  size_in_billion: number | undefined;
  avg_salary_in_inr: number | undefined;
  jobs_in_market_2024: number | undefined;
  id: number | undefined;
  isSubIndustry: boolean;
}) => {
  const cardType = {
    id: id ?? 1,
    size_in_billion: size_in_billion ?? 300,
    avg_salary_in_inr: avg_salary_in_inr ?? 1200,
    jobs_in_market_2024: jobs_in_market_2024 ?? 100
  };
  return <div className="section_industry_stats" data-sentry-component="SectionStats" data-sentry-source-file="index.tsx">
      <div className="section_industry_stats-container">
        {!isSubIndustry && <StatsWithLottie card={cardType} isSubIndustry={false} />}
        {isSubIndustry && <StatsWithLottie card={cardType} isSubIndustry logos={logos} />}
        <div className="section_industry_stats-container-brands">
          <DotLottieReact className="section_industry_stats-container-brands-lottie" src="/images/new/GS-Brands-updated.lottie" autoplay loop speed={1.5} data-sentry-element="DotLottieReact" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </div>;
};
export default SectionStats;